module.exports = __webpack_public_path__ + "static/media/partyprank.39b36bc9.svg";